/**
 * Numeric version comparison for YYYY.M format.
 * Returns true if `candidate` is newer than `baseline`.
 * Handles double-digit months correctly (e.g. "2026.10" > "2026.2").
 */
export function isVersionNewer(candidate: string, baseline: string | null): boolean {
  if (!baseline) return true;

  const [candYear, candMonth] = candidate.split('.').map(Number);
  const [baseYear, baseMonth] = baseline.split('.').map(Number);

  if (candYear !== baseYear) return candYear > baseYear;
  return candMonth > baseMonth;
}
